/* FCC collection (Furniture Cash and Carry, Oct 2026). Ported from Flooring Cash and Carry.
   - "Load more" button
   - Phone floating "Filter & sort" button
   - Card delivery dates (working days, weekend orders start Monday)
   - "Collect today" switch that drives the existing Stocked Product (custom.stock_message) filter
   No dependencies. Works after facets.js re-renders the grid or filters. */
(function () {
  if (window.__fccCollection) return;
  window.__fccCollection = true;

  /* ---------- Load more ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-fcc-next]');
    if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    var label = btn.textContent;
    btn.textContent = 'Loading…';
    var url = new URL(btn.href, window.location.origin);
    url.searchParams.set('section_id', btn.dataset.section);
    fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = document.getElementById('product-grid');
        var frag = document.createDocumentFragment();
        doc.querySelectorAll('#product-grid > li:not(.fcc-grid__item--promo)').forEach(function (li) { frag.appendChild(li); });
        grid.appendChild(frag);
        var shownEl = document.querySelector('[data-fcc-shown]'), newShown = doc.querySelector('[data-fcc-shown]');
        if (shownEl && newShown) shownEl.textContent = newShown.textContent;
        var bar = document.querySelector('[data-fcc-bar]'), newBar = doc.querySelector('[data-fcc-bar]');
        if (bar && newBar) bar.style.width = newBar.style.width;
        var pag = document.querySelector('.fcc-pagination'), newPag = doc.querySelector('.fcc-pagination');
        if (pag && newPag) pag.innerHTML = newPag.innerHTML;
        var next = doc.querySelector('[data-fcc-next]');
        if (next) { btn.href = next.getAttribute('href'); btn.textContent = label; btn.removeAttribute('aria-busy'); }
        else btn.remove();
      })
      .catch(function () { window.location.href = btn.href; });
  });

  /* ---------- Phone floating filter button ---------- */
  function initFloat() {
    var fab = document.querySelector('[data-fcc-float]');
    var opener = document.querySelector('.mobile-facets__open-wrapper');
    if (!fab || !opener || !('IntersectionObserver' in window)) return;
    var grid = document.getElementById('ProductGridContainer');
    var openerVisible = true, gridVisible = false;
    function update() { fab.hidden = openerVisible || !gridVisible; }
    new IntersectionObserver(function (en) { openerVisible = en[0].isIntersecting; update(); }).observe(opener);
    if (grid) new IntersectionObserver(function (en) { gridVisible = en[0].isIntersecting; update(); }).observe(grid);
    fab.addEventListener('click', function () {
      var o = document.querySelector('.mobile-facets__open-wrapper summary') || document.querySelector('.mobile-facets__open-wrapper');
      if (o) o.click();
    });
  }

  /* ---------- Delivery dates ---------- */
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function addWorkingDays(start, n) {
    var d = new Date(start), added = 0;
    while (added < n) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) added++; }
    return d;
  }
  function dateRange(a, b) {
    if (a.getMonth() === b.getMonth()) return a.getDate() + '–' + b.getDate() + ' ' + MONTHS[b.getMonth()];
    return a.getDate() + ' ' + MONTHS[a.getMonth()] + ' – ' + b.getDate() + ' ' + MONTHS[b.getMonth()];
  }
  function fillDelivery() {
    var els = document.querySelectorAll('[data-fcc-delivery]:not([data-fcc-done])');
    if (!els.length) return;
    var start = new Date(); start.setHours(0, 0, 0, 0);
    var day = start.getDay();
    if (day === 6) start.setDate(start.getDate() + 2); else if (day === 0) start.setDate(start.getDate() + 1);
    els.forEach(function (el) {
      var earliest = parseInt(el.getAttribute('data-delivery-earliest'), 10) || 2;
      var latest = Math.max(parseInt(el.getAttribute('data-delivery-latest'), 10) || earliest + 3, earliest);
      var target = el.querySelector('[data-fcc-dates]');
      if (target) target.textContent = dateRange(addWorkingDays(start, earliest), addWorkingDays(start, latest));
      el.setAttribute('data-fcc-done', '');
    });
  }

  /* ---------- "Collect today" switch ---------- */
  var STOCK = 'filter.p.m.custom.stock_message';
  var TARGETS = [
    { form: '#main-collection-filters #FacetFiltersForm', details: 'details.facets__disclosure-vertical', prefix: 'Fcc' },
    { form: '#FacetFiltersFormMobile', details: 'details.mobile-facets__details', prefix: 'FccMobile' }
  ];
  function stockInput(f) {
    return Array.prototype.slice.call(f.querySelectorAll('input[name="' + STOCK + '"]')).filter(function (i) { return i.value.trim() === 'Stock'; })[0];
  }
  function fire(input) { input.dispatchEvent(new Event('input', { bubbles: true })); }
  function toggleRow(id, label, isOn, onChange) {
    var row = document.createElement('label');
    row.className = 'fcc-toggle';
    row.setAttribute('for', id);
    row.innerHTML = '<span class="fcc-toggle__label"></span><input type="checkbox" role="switch" class="fcc-toggle__input"><span class="fcc-toggle__track" aria-hidden="true"></span>';
    row.querySelector('.fcc-toggle__label').textContent = label;
    var cb = row.querySelector('input');
    cb.id = id; cb.checked = isOn;
    // Only the real filter checkbox submits the form; the switch just ticks it
    cb.addEventListener('input', function (e) { e.stopPropagation(); });
    cb.addEventListener('change', function (e) { e.stopPropagation(); onChange(cb.checked); });
    return row;
  }
  function buildToggles(f, t) {
    var s = stockInput(f);
    var existing = f.querySelector('.fcc-toggles');
    if (existing) {
      // facets.js redraws the tick boxes after each filter, so look them up fresh and re-sync
      var cb = f.querySelector('#' + t.prefix + 'ToggleStock');
      if (cb && s) cb.checked = s.checked;
      if (s) { var dd = s.closest('details'); if (dd) dd.classList.add('fcc-hidden-facet'); }
      return;
    }
    if (!s || s.disabled) return;
    var box = document.createElement('div');
    box.className = 'fcc-toggles';
    box.appendChild(toggleRow(t.prefix + 'ToggleStock', 'In stock collect today', s.checked, function (on) {
      var fresh = stockInput(f);
      if (!fresh) return;
      fresh.checked = on; fire(fresh);
    }));
    var d = s.closest('details');
    if (d) d.classList.add('fcc-hidden-facet');
    var first = f.querySelector(t.details);
    if (first && first.parentNode) first.parentNode.insertBefore(box, first); else f.prepend(box);
  }
  function enhanceFilters() {
    TARGETS.forEach(function (t) {
      var f = document.querySelector(t.form);
      if (f) { try { buildToggles(f, t); } catch (e) {} }
    });
  }

  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; fillDelivery(); enhanceFilters(); });
  }
  function init() {
    initFloat();
    fillDelivery();
    enhanceFilters();
    if ('MutationObserver' in window) new MutationObserver(queue).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
